import React, { Component, Fragment } from "react";
import format from "date-fns/format";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";

import EnableDevice from "./EnableDevice";
import LoadingComponent from "../../../../app/layout/LoadingComponent";

import { activateDevice } from "../../../merchants/merchantActions";
import { openSideDrawer } from "../../../sideDrawer/sideDrawerActions";
import classes from "./index.module.css";

class index extends Component {
  state = {
    activateDevicePanelOpen: false,
    selectedDevice: null
  };

  activateDevicePanelOpenClasses = [classes.RevealMore];

  handleDeviceClick = device => {
    this.setState({
      activateDevicePanelOpen: true,
      selectedDevice: device
    });
  };

  handleCloseClick = () => {
    this.setState({
      activateDevicePanelOpen: false,
      selectedDevice: null
    });
  };
  render() {
    let { deviceList, activatpropseDevicerequesting, requesting } = this.props;
    const loading = requesting[`outlet_inventory?where=isActivated:==:false`];
    let { activateDevicePanelOpen, selectedDevice } = this.state;

    let numberOfRecords = deviceList && deviceList.length;

    let attachedClasses = [
      classes.FilterInput,
      classes.FormGroup,
      classes.FormGroupDefault
    ];

    let attachedPaginateActiveClasses = [
      classes.paginate_button,
      classes.active
    ];

    let attachedPaginateSimpleNumbersClasses = [
      classes.dataTables_paginate,
      classes.paging_simple_numbers
    ];

    let attachedPaginateNextClasses = [classes.paginate_button, classes.next];

    if (loading)
      return (
        <Fragment>
          <LoadingComponent inverted={true} />
        </Fragment>
      );

    const devices =
      deviceList &&
      Object.values(deviceList).map((device, index) => {
        return (
          <tr
            className={classes.MerchantRow}
            key={index}
            onClick={() => this.handleDeviceClick(device)}
          >
            <td>{device.outletId}</td>
            <td>{device.model}</td>
            <td>{device.macAddress}</td>
            <td>{device.network}</td>
            <td>{device.cellNumber}</td>
            <td>
              {format(
                device.dateCreated && device.dateCreated.toDate(),
                "YYYY-MM-DD"
              )}
            </td>
          </tr>
        );
      });

    return (
      <Fragment>
        <div className={classes.MerchantTableWrapper}>
          {devices && devices.length === 0 ? (
            <div style={{ paddingBottom: "30px" }}>
              <h3>No devices to approve.</h3>
            </div>
          ) : (
            <Fragment>
              <div className={classes.TableWrapper}>
                <table className={classes.MerchantTable}>
                  <thead>
                    <tr>
                      <th scope="col">Outlet</th>
                      <th scope="col">Model</th>
                      <th scope="col">MAC Address</th>
                      <th className={"hide-s"} scope="col">
                        Network
                      </th>
                      <th className={"hide-s"} scope="col">
                        Cell Number
                      </th>
                      <th className={"hide-s"} scope="col">
                        Date Created
                      </th>
                    </tr>
                  </thead>
                  <tbody>{devices}</tbody>
                </table>

                {activateDevicePanelOpen ? (
                  <div className={classes.EnableDevice}>
                    <div className={classes.EnableDevice}>
                      <div className={"card card-transparent"}>
                        <div
                          className={"card-header "}
                          style={{
                            padding: "0",
                            minHeight: "4.1rem",
                            padding: "1rem",
                            color: "#666",
                            fontSize: "1.4rem",
                            fontFamily: "Roboto",
                            fontWeight: "500"
                          }}
                        >
                          <div
                            className={"card-title semi-bold"}
                            style={{
                              color: "#666",
                              fontSize: "1.4rem",
                              fontFamily: "Roboto",
                              fontWeight: "500",
                              textTransform: "none",
                              marginLeft: "0.7rem"
                            }}
                          >
                            Enable Device
                          </div>
                          <div className={"card-controls"}>
                            <ul>
                              <li>
                                <a
                                  data-toggle="close"
                                  className={"card-close"}
                                  href="#"
                                  onClick={this.handleCloseClick}
                                >
                                  <i className={"card-icon card-icon-close"} />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className={"card-body"}>
                          <div className={"panel"}>
                            <Fragment>
                              <ul
                                className={
                                  "nav nav-tabs nav-tabs-simple d-none d-md-flex d-lg-flex d-xl-flex"
                                }
                              >
                                <li className={"nav-item active"}>
                                  <a
                                    data-toggle="tab"
                                    href="#activation"
                                    className={"active show"}
                                  >
                                    Enable Device
                                  </a>
                                </li>
                              </ul>
                              <div className={"tab-content"}>
                                <div
                                  className={"tab-pane active"}
                                  id="activation"
                                >
                                  <div className={"row column-seperation"}>
                                    <div className={"col-md-12"}>
                                      <EnableDevice
                                        deviceId={selectedDevice.id}
                                        outletId={selectedDevice.outletId}
                                        account={selectedDevice.account}
                                        closePanel={this.handleCloseClick}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className={classes.Row}>
                <div>
                  <div
                    className={attachedPaginateSimpleNumbersClasses.join(" ")}
                  >
                    <ul>
                      <li>
                        <a href="">
                          <i className={classes.pg_arrow_left} />
                        </a>
                      </li>
                      <li className={attachedPaginateActiveClasses.join(" ")}>
                        <a href="">1</a>
                      </li>
                      <li
                        className={attachedPaginateNextClasses.join(" ")}
                        id="tableWithExportOptions_next"
                      >
                        <a href="">
                          <i className={classes.pg_arrow_right} />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div
                    className={classes.dataTables_info}
                    id="tableWithExportOptions_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing <b>1 to {numberOfRecords}</b> of {numberOfRecords}
                    entries
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

let query = [
  {
    collection: "outlet_inventory",
    where: ["isActivated", "==", false]
  }
];

const mapStateToProps = state => ({
  deviceList: state.firestore.ordered.outlet_inventory,
  requesting: state.firestore.status.requesting
});

const actions = {
  activateDevice,
  openSideDrawer
};

export default connect(
  mapStateToProps,
  actions
)(firestoreConnect(query)(index));
